<template>
  <ScoutPopupModal>
    <template #body>
      <div class="scout-popup__top-area">
        <InlineSvg :src="require('../images/receive_mail.svg')" />
        <div class="scout-popup__heading-message">{{ items.length }}件のスカウトが届いています</div>
      </div>
      <div class="scout-popup__list">
        <ScoutPopupListItem v-for="item in items" :key="item.company.id" :item="item" />
      </div>
      <div class="scout-popup__bottom-area">
        <OCButton label="全てのスカウトを見る" url="/my/messages" />
        <a href="#" class="scout-popup__close-link" @click.prevent="$emit('close')">後で確認する</a>
      </div>
    </template>
  </ScoutPopupModal>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api';
import { ScoutPopupItem } from 'oc2api/popup';
import ScoutPopupModal from 'components/popup/ScoutPopup/ScoutPopupModal.vue';
import ScoutPopupListItem from 'components/popup/ScoutPopup/ScoutPopupListItem.vue';
import OCButton from 'components/popup/OCButton.vue';

export default defineComponent({
  name: 'ScoutPopup',
  components: {
    ScoutPopupModal,
    ScoutPopupListItem,
    OCButton,
  },
  props: {
    items: {
      type: Array as PropType<ScoutPopupItem[]>,
      required: true,
    },
  },
  emits: {
    close: () => true,
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.scout-popup__list {
  max-height: 240px;
  padding: 8px 12px;
  background: $oc-area-bg;
  overflow-x: hidden;
  overflow-y: auto;
}

.scout-popup__top-area {
  text-align: center;
  margin-bottom: 16px;
}

.scout-popup__heading-message {
  margin-top: 16px;
  text-align: center;
  font-size: 22px;
  line-height: 33px;
  font-weight: 600;
  color: $oc-black;
}

.scout-popup__bottom-area {
  padding: 16px 12px 0;
  text-align: center;
}

.scout-popup__close-link {
  display: block;
  margin-top: 12px;
  font-size: 12px;
  line-height: 20px;
  font-weight: 600;
  color: $oc-gray80;
}
</style>
